import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=5abb8572&scoped=true"
import script from "./ToggleSwitch.vue?vue&type=script&lang=js"
export * from "./ToggleSwitch.vue?vue&type=script&lang=js"
import style0 from "./ToggleSwitch.vue?vue&type=style&index=0&id=5abb8572&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abb8572",
  null
  
)

export default component.exports